/**
 * Text normalization used for diacritics- and case-insensitive matching of
 * field labels, operator words and values.
 */
/** Strips diacritics, lowercases and collapses inner whitespace. */
export var normalize = function (text) {
    return text
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
};
/** Splits a label into normalized words. */
export var normalizeWords = function (text) {
    return normalize(text).split(' ').filter(Boolean);
};
/** True when `value` starts with `prefix` after normalization. */
export var normalizedStartsWith = function (value, prefix) {
    return normalize(value).startsWith(normalize(prefix));
};
/** True when `value` contains `needle` after normalization. */
export var normalizedIncludes = function (value, needle) {
    return normalize(value).includes(normalize(needle));
};
